import { render } from "./BeingRevisedReason.vue?vue&type=template&id=1a4bcfa2"
import script from "./BeingRevisedReason.vue?vue&type=script&lang=js"
export * from "./BeingRevisedReason.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__